<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM各类别板材工厂用量"
      rightTitle="2022年12月 合计：2222"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
    <div id="right_4" slot="main"/>
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "right_4",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_4"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: "right",
          top: "center",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
          "#AFEEEE",
        ],
        series: [
          {
            name: "PDM各类别板材工厂用量",
            type: "pie",
            radius: "70%",
            right: "22%",
            data: [
              { value: 248, name: "普通E0级颗粒板" },
              { value: 735, name: "露水河E0级颗粒板" },
              { value: 580, name: "露水河ENF级颗粒板" },
              { value: 484, name: "露水河OSB板" },
              { value: 100, name: "爱格板" },
              { value: 600, name: "PET" },
              { value: 200, name: "禾香板" },
              { value: 400, name: "鲁丽" },
              { value: 400, name: "彝丰" },
              { value: 100, name: "芦花" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}: \n {@2012}",
              color: "#C0C4CC",
            },
            labelLine: {
              length: 5,
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #right_4 {
    height: 100%;
  }
}
</style>
